/**
 * Created by djacobsmeyer on 5/8/17.
 */

import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../../services/UserService';
import {SecurityService} from '../../../../services/SecurityService';
import {User} from '../../../../services/api.client';
import {Observable} from 'rxjs';
import {SystemService} from '../../../../services/SystemService';
import {NotificationService} from '../../../../services/NotificationService';
import {Router} from '@angular/router';

@Component({
    selector: 'support-agreement',
    templateUrl: './SupportAgreementComponent.html',
    styleUrls: ['./SupportAgreementComponent.scss'],
    standalone: false
})

export class SupportAgreementComponent implements OnInit {
    userHasAgreed: boolean;

    loggedInUser: User;
    loggedInUser$: Observable<User>;

    constructor(
        private userService: UserService,
        private systemService: SystemService,
        private securityService: SecurityService,
        private notificationService: NotificationService,
        private router: Router
    ) {
        this.loggedInUser$ = this.securityService.currentUser$;
    }

    ngOnInit(): void {
        this.loggedInUser$
            .subscribe((user) => {
                this.loggedInUser = user;
                this.userHasAgreed = user.uwAgreementDate && this.systemService.loggedInUserHasAgreed();
            });
    }

    saveAgreementDate(): void {
        this.userService.setAgreementDate(new Date())
            .subscribe(() => {
                this.notificationService.showSuccess('You must log back in for changes to take effect.');
                this.securityService.logout();
            });
    }
}
